// extracted by mini-css-extract-plugin
module.exports = {"topNavDesktopBar":"top-nav-desktop-bar_topNavDesktopBar__Dyf2U","shippingLink":"top-nav-desktop-bar_shippingLink__rDLWu","busuinessLink":"top-nav-desktop-bar_busuinessLink__pIGuR"};